exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleContent[data-v-413e7101]{border:2px solid #fff;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;padding:0 14px;min-height:1px;position:relative}.titleContent h2[data-v-413e7101],.titleContent p[data-v-413e7101]{word-wrap:break-word;min-height:1px}.titleContent .more[data-v-413e7101]{font-size:10px;color:#969799;text-align:center}.titleContent .more.lef[data-v-413e7101]{position:absolute;right:15px;top:12px}", ""]);

// exports
